import { RadioItemConfigType } from 'src/lib/types/random'

export const CreditNameVisibiltyOptions: RadioItemConfigType[] = [
  {
    label: 'Show',
    valueType: 'block'
  },
  {
    label: 'Hide',
    valueType: 'none'
  }
]

export const OutlineOptions: RadioItemConfigType[] = [
  {
    label: 'Solid',
    valueType: 'solid',
    endIcon: <div className='w-10 mt-2 border-t-2 border-solid border-black'></div>
  },
  {
    label: 'Dash',
    valueType: 'dashed',
    endIcon: <div className='w-10 mt-2 border-t-2 border-dashed border-black '></div>
  }
]
